module.exports = __webpack_public_path__ + "media/images/emoticons/snail-112b6eac6d02bda35724206f8bc3b16b.gif";